/**
 * Cliente tipado da API do Odus. Os tipos vêm de `schema.d.ts`, gerado do OpenAPI da API
 * (`pnpm gen:api`); o CI falha se a API mudar e o cliente não for regenerado.
 */
import createClient, { type Client } from "openapi-fetch";

import type { paths } from "./schema";

export type { components, paths } from "./schema";

export type ApiClient = Client<paths>;

export type ApiClientOptions = {
  baseUrl: string;
  /** Devolve o JWT da sessão (Supabase Auth); sem token, a chamada vai sem `authorization`. */
  getToken?: () => Promise<string | undefined>;
};

export function createApiClient({ baseUrl, getToken }: ApiClientOptions): ApiClient {
  // Busca o `fetch` na hora de cada chamada (e não na criação do cliente).
  const client = createClient<paths>({ baseUrl, fetch: (req) => globalThis.fetch(req) });
  if (getToken) {
    client.use({
      async onRequest({ request }) {
        const token = await getToken();
        if (token) request.headers.set("authorization", `Bearer ${token}`);
        return request;
      },
    });
  }
  return client;
}
